
import {
  GET_BADGE_BANNER_DATA,
  GET_REVIEW_ITEM_DATA,
  GET_CONTACT_DETAIL_DATA,
} from '~/api/apolloReviewQueries';

export default {
  name: 'ReviewsPage',
  data() {
    return {
      bannerData: null,
      badgeData: null,
      contactDetailData: null,
      reviewItems: [],
      reviewDescription: null,
      isBadgeBannerLoading: false,
      isContactDetailLoading: false,
      isReviewDataLoading: false,
      totalItems: null,
      perPage: null,
      page: null,
      titleDetails: null,
    };
  },
  computed: {
    breadcrumbs() {
      const breadcrumbs = [...(this.$store.state.metaData?.addons?.breadcrumbs || [])];
      if (breadcrumbs[0]) {
        breadcrumbs[0] = { ...breadcrumbs[0], isInternal: true };
      }
      return breadcrumbs;
    },
  },
  methods: {
    async getReviewData() {
      const defaultParams = { ...this.$store.state.reviews.defaultParams };
      this.isReviewDataLoading = true;
      try {
        const { reviewPage } = await this.$graphql.default.request(
          GET_REVIEW_ITEM_DATA,
          defaultParams,
        );
        if (reviewPage) {
          this.reviewItems = reviewPage.reviewItems.items;
          this.totalItems = reviewPage.reviewItems.itemsCount;
          this.perPage = reviewPage.reviewItems.perPage;
          this.page = reviewPage.reviewItems.page;
          this.titleDetails = reviewPage.titleDetails;
        }
      } catch (error) {
        console.error('Error fetching review items:', error);
      } finally {
        this.isReviewDataLoading = false;
      }
    },
    async getInitialData() {
      const getBadgeBannerData = async () => {
        this.isBadgeBannerLoading = true;
        try {
          const { reviewPage } = await this.$graphql.default.request(
            GET_BADGE_BANNER_DATA,
          );
          if (reviewPage) {
            this.bannerData = reviewPage.banner;
            this.badgeData = reviewPage.badge;
          }
        } catch (error) {
          console.error('Error fetching badge/banner data:', error);
        } finally {
          this.isBadgeBannerLoading = false;
        }
      };

      const getContactDetailData = async () => {
        this.isContactDetailLoading = true;
        try {
          const { reviewPage } = await this.$graphql.default.request(
            GET_CONTACT_DETAIL_DATA,
          );
          if (reviewPage) {
            this.contactDetailData = reviewPage.contact;
            this.reviewDescription = reviewPage.description;
          }
        } catch (error) {
          console.error('Error fetching contact details:', error);
        } finally {
          this.isContactDetailLoading = false;
        }
      };
      try {
        await Promise.allSettled([
          getBadgeBannerData(),
          getContactDetailData(),
          this.getReviewData(),
        ]);
      } catch (error) {
        console.error(error);
      }
    },
  },
  async fetch() {
    let pageFromQuery = this.$route.query.p ? parseInt(this.$route.query.p, 10) : 1;
    if (pageFromQuery < 1 || Number.isNaN(pageFromQuery)) {
      const { p, ...restQuery } = this.$route.query;
      this.$router.replace({ query: restQuery });
      pageFromQuery = 1;
    }
    this.$store.dispatch('reviews/updatePage', pageFromQuery);
    await this.getInitialData();
  },
};
